var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Archive",
    transform: "translate(-263 -194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8611",
    "data-name": "Rectangle 8611",
    width: 18,
    height: 18,
    transform: "translate(263 194)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1608512_archive_icon",
    "data-name": "1608512_archive_icon",
    d: "M69.831,132.009a.37.37,0,0,0-.364-.364H68.009a.364.364,0,0,0,0,.729h1.458a.37.37,0,0,0,.364-.364Zm3.28-1.093v5.467a.37.37,0,0,1-.364.364H64.729a.37.37,0,0,1-.364-.364v-5.467a.37.37,0,0,1,.364-.364h8.018a.37.37,0,0,1,.364.364Zm.364-2.551v1.458a.37.37,0,0,1-.364.364H64.364a.37.37,0,0,1-.364-.364v-1.458a.37.37,0,0,1,.364-.364h8.747a.37.37,0,0,1,.364.364Z",
    transform: "translate(203 71)",
    fill: "#1b1c1d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.802fa55722645aadf097342ea590a91c.svg";
export { ForwardRef as ReactComponent };